<template>
    <div class="app-container">
        <app-header></app-header>
        <div class="content">
            <router-view></router-view>
        </div>
        <!-- <div class="push"></div> -->
        <app-footer></app-footer>
        <app-cookie-consent></app-cookie-consent>
    </div>
</template>

<script>
import Header from "./components/common/HeaderNew.vue"
import Footer from "./components/common/FooterNew.vue"
import CookieConsent from "./components/common/CookieConsent.vue"
import './assets/styles.css'
import { mapActions } from 'vuex'

export default {
    components: {
        appHeader: Header,
        appFooter: Footer,
        appCookieConsent: CookieConsent
    },
    methods: {
        ...mapActions(["loadLanguages", "loadContents", "fetchAccessTokenInitial"]),
    },
    created() {
        this.loadLanguages();
        this.loadContents();
        this.fetchAccessTokenInitial();
    },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Oswald:wght@200..700&family=PT+Sans+Narrow:wght@400;700&display=swap');

html {
    position: relative;
    min-height: 100%;
    /* scroll-behavior: smooth; */
}

html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
}

h1,h2 {
    font-family: "PT Sans Narrow", sans-serif;
    font-weight: 400;
    font-style: normal;
}

h3, h4, h5, h6 {
    font-family: "PT Sans Narrow", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.push {
    height: 20vh;
}

.footer {
    /* position: absolute; */
    bottom: 0;
    margin-top: auto;
}

.app-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.content {
    /* padding: 30px 5%; */
    flex-grow: 1;
    padding: 0%;
    background-color: var(--light-color);
}

div {
    font-family: "PT Sans Narrow", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.pagination .page-link {
    color: var(--main-color);
}


.pagination .page-item.active .page-link {
    background-color: var(--main-color) !important;
    color: white !important;
}

.form-control,
.vs__dropdown-toggle,
.custom-file-label,
.vue-treeselect__control,
.vue-treeselect__menu,
.vs_dropdown-menu, 
.vs__selected-options input{
    background-color: var(--light-color) !important;
}

#v3_listbox, .vs__dropdown-menu{
    background-color: var(--light-color) !important;
}


@media only screen and (max-width: 600px) {

    .push {
        height: 45vh;
    }
}

@media only screen and (max-width: 300px) {

    .push {
        height: 50vh;
    }
}

.custom-file-input:lang(en)~.custom-file-label::after {
    content: 'Browse';
}

.custom-file-input:lang(bs)~.custom-file-label::after {
    content: 'Odaberi';
}

.custom-file-input:lang(hr)~.custom-file-label::after {
    content: 'Odaberi';
}
</style>
